import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { scrollToId } from "./SmoothScroll";

// Primary + secondary editorial CTA button.
export const CtaButton = ({
  children,
  variant = "primary",
  targetId = "plan",
  to,
  onClick,
  withIcon = true,
  className = "",
  testId,
}) => {
  const navigate = useNavigate();
  const base =
    "group inline-flex items-center gap-3 px-8 py-4 font-sans text-sm uppercase tracking-[0.18em] transition-colors duration-500 rounded-none cursor-pointer";
  const styles =
    variant === "primary"
      ? "bg-teal text-ink hover:bg-cream"
      : variant === "onTeal"
      ? "bg-ink text-cream hover:bg-cream hover:text-ink"
      : "border border-charcoal text-cream hover:border-teal hover:text-teal bg-transparent";

  const handle = (e) => {
    if (onClick) return onClick(e);
    if (to) return navigate(to);
    if (targetId) scrollToId(targetId);
  };

  return (
    <button data-testid={testId} onClick={handle} className={`${base} ${styles} ${className}`}>
      <span>{children}</span>
      {withIcon && (
        <ArrowUpRight
          size={16}
          strokeWidth={1.6}
          className="transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      )}
    </button>
  );
};
